import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { selectWork } from '../../Api/selectors';
import { fetchCompany } from '../actions';
import { REQUEST_COMPANY } from '../constants';
import { selectCompany } from '../selectors';
import { CardCompanyHeader } from './CardCompanyHeader';

const Container = styled.div`
  width: 100%;
`;

const STATE = {
  isHome: null,
  vehicleProps: null,
};

/* eslint-disable react/prefer-stateless-function */
class FINCompanyCardComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCompany();
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <CardCompanyHeader bottomStatus company={this.props.company} />
      </Container>
    );
  }
}

FINCompanyCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_COMPANY),
    company: selectCompany(ownProps.companyId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCompany(callback) {
      dispatch(fetchCompany(ownProps.companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FINCompanyCard = compose(withConnect, withRouter)(FINCompanyCardComp);
